import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 성능/운영분석 화면 / 시스템 접근 정보 화면의
   * 접속 이력 리스트를 가져온다.
   * @author {Yang}
   * @param  {[data]} params [StartDatetime, endDateTime]
   * @return {[List<SmsLogSystemconn>]}  [접속 이력 리스트]
   */
  getLogSystemconnList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-logsystemconn-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / 시스템 접근 정보 화면의
   * 계정 전환 리스트를 가져온다.
   * @author {Yang}
   * @param  {[data]} params [startDatetime, endDatetime]
   * @return {[List<>]}  [계정 전환 리스트]
   */
  getAccountSwitchingList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-account-switch-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / 시스템 접근 정보 화면의
   * 암호 변경 리스트를 가져온다.
   * @author {Yang}
   * @param  {[data]} params [startDatetime, endDatetime]
   * @return {[List<SmsLogChngpasswdHist>]}  [암호 변경 리스트]
   */
  getLogChngpasswdHistList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-chngpassword-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / 시스템 접근 정보 화면의
   * 차단 이력 리스트를 가져온다.
   * @author {Yang}
   * @param  {[data]} params [startDatetime, endDatetime]
   * @return {[List<SmsLogPortctrlHist>]}  [차단 이력 리스트]
   */
  getSmsLogPortctrlHistList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-logportctrlhist-list.do`, params);
  },
  /**
   * 성능 / 운영 > 분석 > 프로세스 정보 : 스냅샷 리스트를 가져온다.
   * @author {Yang}
   * @return {objId, baselineDatetime, managetypeId}
   */
  getSmsProcessInfoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-process-list.do`, params);
  },
  /**
   * 성능 / 운영 > 분석 > 프로세스 정보 : 현재 리스트를 가져온다.
   * @author {yelim}
   * @return {Map}
   */
  getCurrentProcessInfoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-current-process-list.do`, params);
  },
  /**
   * [성능/운영>요약] Server 성능위젯 정보 조회
   * @author kimjy
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getSummaryRscRsltList(params) {
    return axios.post(`${baseUrl}/performance/summary/server/get-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-list.do`, params);
  },
  /**
   * [성능/운영>요약] Server 성능위젯 정보 조회 (후면)
   * @author kimjy
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getSummaryRscRsltBackList(params) {
    return axios.post(`${baseUrl}/performance/summary/server/get-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-back-list.do`, params);
  },
  /**
   * [성능/운영>요약] 서버 구성정보 위젯 정보 조회
   * @author jeee12
   * @param  {Object} params objId, managegroupId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  getServerConfigurationInfo(params) {
    return axios.get(`${baseUrl}/performance/summary/server/get-configuration-info.do`, { params });
  },
  /**
   * 성능/운영분석 화면 / TCP/UDP 포트 리스트를 가져온다.
   * @author {Yang}
   * @param  {[data]} params [objID]
   * @return {[List<SmsLogSystemconn>]}  [TCP/UDP 포트 리스트]
   */
  getPortSettingsCertificationList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-tcp-udp-settings-certification-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / TCP/UDP 포트 리스트를 가져온다.
   * @author {Yang}
   * @param  {[data]} params [objID]
   * @return {[List<SmsLogSystemconn>]}  [TCP/UDP 포트 리스트]
   */
  getPortSettingsMajorList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-tcp-udp-settings-major-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / TCP/UDP 포트 리스트를 업데이트(삽입) 한다.
   * 서비스 포트 설정 탭
   * @author {Yang}
   * @param  {[data]} params [objID, saveList]
   * @return {[boolean  [success]
   */
  updateMajorPort(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/update-tcp-udp-settings-major-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / TCP/UDP 포트 리스트를 업데이트(삽입) 한다.
   * 포트 인증/비인증 탭
   * @author {Yang}
   * @param  {[data]} params [objID, saveList]
   * @return {[boolean  [success]
   */
  updateCertificationPort(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/update-server-tcp-udp-settings-certification-list.do`, params);
  },
  /**
   * TCP/UDP 포트 스냅샷을 조회한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getTcpUdpPortSnapshot(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-tcp-udp-port-snapshot.do`, params);
  },
  /**
   * TCP/UDP 포트 현재 정보를 조회한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getCurrentTcpUdpPort(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-current-tcp-udp-port.do`, params);
  },
  /**
   * 세션 스냅샷을 조회한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSessionSnapshot(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-session-snapshot.do`, params);
  },
  /**
   * 현재 세션 정보를 조회한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getCurrentSession(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-current-session.do`, params);
  },
  /**
   * 성능/운영분석 화면 / 시스템 접근 정보 화면의
   * 파일 접근 리스트를 가져온다.
   * TODO JSON파일을 리턴하기 때문에 변경 필요
   * @author {Yang}
   * @param  {[data]} params [StartDatetime, endDateTime]
   * @return {[JSON파일]}  [파일 접근 리스트]
   */
  getFileAccessList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-file-access-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / 프로세스 화면에서 과점유 설정 데이터를 가져온다.
   * @author {Yang}
   * @param  {[data]} params [objID]
   * @return {[boolean]}  [process_max_cpu_limit, process_max_mem_limit]
   */
  getProcessOverloadSettings(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-process-overload-settings.do`, { objId: params });
  },
  /**
   * 성능/운영분석 화면 / 프로세스 화면에서 과점유 설정 데이터를 업데이트 한다.
   * @author {Yang}
   * @param  {[data]} params [objID, process_max_cpu_limit, process_max_mem_limit]
   * @return {[boolean]}  [sucess]
   */
  updateProcessOverloadSettings(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/update-process-overload-settings.do`, params);
  },
  /**
   * [성능/운영 > 슬라이딩 팝업 > 명령어 수행] 스크립트 실행 리스트 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getServerPerformCommandList(params) {
    return axios.post(`${baseUrl}/performance/get-server-perform-command-list.do`, params);
  },
  /**
   * [executeServerAgentRemoteControl 성능/운영 > 슬라이딩 팝업 > agent 원격 제어 (시작, 중지, 재시작)]
   * @author {Yang}
   * @param  {[type]} params [executeType(String), targetList[{objId, ipaddress}]]
   * @return {[type]}        [description]
   */
  executeServerAgentRemoteControl(params) {
    return axios.post(`${baseUrl}/performance/execute-server-agent-remote-control.do`, params);
  },
  /**
   * [성능/운영 > 슬라이딩 팝업 > 명령어 수행] 명령어 수행
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  executeCLI(params) {
    return axios.post(`${baseUrl}/performance/execute-cli.do`, params);
  },
  /**
   * [executeDeviceInfoUpdate 성능/운영 > 슬라이딩 팝업 > 장비 정보 업데이트]
   * @author {Yang}
   * @param  {[type]} params [objId]
   * @return {[type]}        [description]
   */
  executeDeviceInfoUpdate(params) {
    return axios.post(`${baseUrl}/performance/execute-server-update-device-info.do`, params);
  },
  /**
   * [getServerRealtimeControlList 성능/운영 > 슬라이딩 팝업 > 실시간 제어 팝업 리스트(major) 가져오기.]
   * @author {Yang}
   * @param  {[type]} params [objId]
   * @return {[type]}        [description]
   */
  getServerProcess(params) {
    return axios.post(`${baseUrl}/performance/get-server-process.do`, params);
  },
  /**
   * [executeServerStartMajorProcess 서버 > 슬라이딩 팝업 > 실시간 제어 팝업에서 프로세스 시작 명령어를 실행한다.]
   * @author {Yang}
   * @param  {[type]} params [objId, processCommandStart]
   * @return {[type]}        [description]
   */
  executeServerStartMajorProcess(params) {
    return axios.post(`${baseUrl}/performance/execute-server-start-major-process.do`, params);
  },
  /**
   * [executeServerStopMajorProcess 서버 > 슬라이딩 팝업 > 실시간 제어 팝업에서 프로세스 중지 명령어를 실행한다.]
   * @author {Yang}
   * @param  {[type]} params [objId, processCommandStart]
   * @return {[type]}        [description]
   */
  executeServerStopMajorProcess(params) {
    return axios.post(`${baseUrl}/performance/execute-server-stop-major-process.do`, params);
  },
  killProcess(params) {
    return axios.post(`${baseUrl}/performance/kill-process.do`, params);
  },
  /**
   * 성능/운영 > 서버 분석 > 시스템 접근 > 현재 접속 이력 데이터 조회
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getSystemConnCurList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-current-logsystemconn-list.do`, params);
  },
  /**
   * 성능/운영 > 운영 탭 > TCP/UDP 포트 - 관심 포트 목록 조회
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author Song
   */
  getCurrentMajorServicePortList(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-current-major-service-port-list.do`, params);
  },
  /**
   * 서비스 이름별 주요 세션 카운트 조회
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author najong
   */
  getMajorSessionCountByService(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/get-major-session-count-by-service.do`, params);
  },
  /**
   * 성능조회 > 노드 > 분석/운영 > 세션메뉴 TCP 관심 포트 설정 기능
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author najong
   */
  updateTcpSessionPort(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/update-tcp-session-port.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/server/info-table.js